
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.546.145a2.242 2.242 0 00-1.078 4.207l-4.547 11.143a2.243 2.243 0 00-1.887.196l-4.833-5.534a2.238 2.238 0 10-.598.523l4.834 5.533c-.32.397-.492.891-.492 1.4 0 1.238.88 2.242 2.242 2.242s2.241-1.004 2.241-2.242a2.235 2.235 0 00-.81-1.725l4.604-11.283a2.241 2.241 0 10.324-4.46z","fill":"#fff"}})])
          )
        }
      }
    